import type { AllocNode } from "./buildAllocationTree";

export function VlanTable({ vlans }: { vlans: AllocNode[] }) {
  if (vlans.length === 0) return <p style={{ color: "var(--text-dim)" }}>No VLANs generated yet.</p>;
  return (
    <table style={{ width: "100%", fontSize: "0.85rem" }}>
      <thead>
        <tr><th align="left">Tag</th><th align="left">Name / CIDR</th><th align="left">DHCP</th></tr>
      </thead>
      <tbody>
        {vlans.map((v) => (
          <tr key={v.key}>
            <td>{v.vlanTag ?? "—"}</td>
            <td>{v.label}<br /><span style={{ color: "var(--text-dim)" }}>{v.cidr ?? "—"}</span></td>
            <td>{(v.dhcpRanges ?? []).map((d) => `${d.range_start ?? "?"}–${d.range_end ?? "?"}`).join(", ") || "—"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
